export default __webpack_public_path__ + "static/media/mobile-version.5924024f.png";